import React, { useEffect, useState } from 'react'
import CustomizedDialogs from '../../../common/CustomizedDialogs'
import { Box, Divider } from '@mui/material'
import CustomDatePicker from '../../../common/CustomDatePicker'
import dayjs from 'dayjs'
import DropDownV3 from '../../../common/DropDownV3'
import MButton from '../../../common/MButton'
import { useDispatch, useSelector } from 'react-redux'
import { getAgentUsersListAll } from '../../../redux/Report/ReportActions'
import { showErrorAlert } from '../../../redux/Actions'
import { encryptText } from '../../../utils/encrypt'

const UserCollectionModal = (props) => {
    const { open = false, titleText = '', onClose = () => { } } = props
    const dispatch = useDispatch();
    const store = useSelector((store) => store);
    const { user } = store;
    const { userDetails } = user;
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [filterOpt, setFilterOpt] = useState({
        agent: []
    })
    const [filterValue, setFilterValue] = useState({
        agent: [],
        toDate: dayjs(window.getTime ? window.getTime() : new Date()),
        fromDate: dayjs(window.getTime ? window.getTime() : new Date())
    })
    useEffect(() => {
        if (userDetails?.AgentID) {
            fetchAgentList()
        }

    }, [userDetails?.AgentID])
    const userProps = () => {
        return {
            width: "100%",
            name: "user",
            id: 'user',
            label: "User",
            isCompulsory: false,
            options: filterOpt.agent || [],
            preSelectedValues: filterValue?.agent || [],
            searchPlaceholder: "Search by User",
            disabled: false,
            isObject: true,
            primaryKey: 'AgentUserID',
            labelKey: 'AgentUserName',
            singleSelect: true,
            selectAllOption: true,
            defaultAllSelected: true,
            nextId: 'remarks',
            prevId: 'DropOff',
        }
    }

    const fetchAgentList = () => {
        const body = {
            intAgentUserID: 0,
            intAgentID: userDetails?.AgentID,
            intIsActive: 1
        }
        dispatch(getAgentUsersListAll(body)).then((res) => {
            if (res.data.status) {
                setFilterOpt((prev) => ({
                    ...prev,
                    agent: res.data.Data?.Table || []
                }))
                setFilterValue((prev) => ({
                    ...prev,
                    agent: res.data.Data?.Table || []
                }))
                setIsModalVisible(true)
            } else {
                dispatch(showErrorAlert(res.data.Message))
            }
        })
    }
    return (
        <CustomizedDialogs
            open={open && isModalVisible}
            titleText={titleText}
            width={'450px'}
            height={'auto'}
            onClose={onClose}
            padding={'0px'}
        >
            <Box sx={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <Box className='date_pickerV40'>
                    <CustomDatePicker label='From Date' id='journey_Date' selectedDate={filterValue.fromDate}
                        onChange={(date) => {
                            if (new Date(date) < new Date(filterValue.toDate)) {
                                setFilterValue({ ...filterValue, fromDate: date })
                            } else {
                                setFilterValue({ ...filterValue, fromDate: date, toDate: date })
                            }
                        }}
                        minDate={null}
                    />
                </Box>
                <Box className='date_pickerV40'>
                    <CustomDatePicker label='To Date' id='journey_Date' selectedDate={filterValue.toDate}
                        onChange={(date) => {
                            setFilterValue((prev) => ({
                                ...prev,
                                toDate: date
                            }))
                        }}
                        minDate={filterValue.fromDate}
                    />
                </Box>

                <Box>
                    <DropDownV3
                        {...userProps()}
                        onSelect={(val) => {
                            setFilterValue((prev) => ({
                                ...prev,
                                agent: val
                            }))
                        }}
                    />
                </Box>
            </Box>
            <Divider sx={{ borderColor: '#cccccc' }} />
            <Box sx={{ display: 'flex', justifyContent: 'end', gap: '8px', padding: '12px 16px' }}>
                <MButton variant='outlined' btnName="Close" onClick={onClose} />
                <MButton btnName="Generate"
                    onClick={() => {
                        const params = {
                            fromDate: filterValue.fromDate.format('YYYY-MM-DD'),
                            toDate: filterValue.toDate.format('YYYY-MM-DD'),
                            agentUserID: filterValue.agent.length === 1 ? filterValue.agent?.[0].AgentUserID : -1,
                            agentID: userDetails.AgentID,
                            agentUser: filterValue.agent.length === 1 ? filterValue.agent?.[0].AgentUserID : 'ALL USERS'
                        }
                        window.open(`/userCollectionReport?data=${encodeURIComponent(encryptText(JSON.stringify(params)))}`, "_blank");
                    }}
                />
            </Box>
        </CustomizedDialogs>
    )
}

export default UserCollectionModal